import React from 'react';
import { ApiTopProducts } from '../apifolder/TopProductsApi';
import Product from './Product';

const Products = ({ onChangePage }) => {
  return (
    <div className="flex flex-wrap m-6 mt-9 gap-5 justify-center items-center">
      {ApiTopProducts.map((product, index) => {
        return <Product product={product} key={index} onChangePage={onChangePage} />;
      })}
    </div>
  );
};

export default Products;
